import Auth from './Auth';
import Login from './Login/Login';
import Register from './Register/Register';
import RegisterStepCompany from './Register/RegisterStepCompany.vue';
import RegisterStepComment from './Register/RegisterStepComment.vue';
import RegisterStepCompaniesList from './Register/RegisterStepCompaniesList.vue';
import RegisterStepCompanies from './Register/RegisterStepCompanies.vue';
import ForgotPassword from './ForgotPassword/ForgotPassword';

export default {
    path: '/auth',
    component: Auth,
    children: [
      {
        path: '',
        name: 'auth-login',
        component: Login,
      },
      {
        path: 'register',
        name: 'auth-register',
        component: Register,
      },
      {
        path: 'register-company',
        name: 'auth-register-company',
        component: RegisterStepCompany,
      },
      {
        path: 'register-companies-list',
        name: 'auth-register-companies-list',
        component: RegisterStepCompaniesList,
      },
      {
        path: 'register-companies',
        name: 'auth-register-companies',
        component: RegisterStepCompanies,
      },
      {
        path: 'register-comment',
        name: 'auth-register-comment',
        component: RegisterStepComment,
      },
      {
        path: 'register-forgot-password',
        name: 'auth-register-forgot-password',
        component: ForgotPassword,
      },
    ],
  };